module.exports = __webpack_public_path__ + "static/img/bg_01.88323e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_01.jpg
// module id = V3Wx
// module chunks = 3